<template>
    <div class="side-card">
        <slot name="header" />
        <slot />
        <slot name="footer" />
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">
.side-card {
    margin-top: 48px;
    margin-bottom: 24px;
    position: relative;
    padding-bottom: 10px;

    header {
        margin: 0 auto;
        max-width: 100%;
        position: relative;
        box-sizing: border-box;
        padding: 0 20px;
        display: block;
        height: auto;

        div {
            display: block;
            width: 100%;
        }

        .title {
            font-size: 18px;
            padding: 15px 0 0;
        }

        .description {
            font-size: 14px;
            padding: 5px 0 15px;
        }
    }

    main {
        box-sizing: border-box;
        padding: 0 20px;
    }

    footer {
        box-sizing: border-box;
        margin: 20px 20px 0 20px;
        padding: 10px 0 3px 0;
        border-top: 1px solid rgba(0,0,0,.06);
    }
}
</style>


